import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=0804f336&"
import script from "./Ranking.vue?vue&type=script&lang=ts&"
export * from "./Ranking.vue?vue&type=script&lang=ts&"
import style0 from "./Ranking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0804f336')) {
      api.createRecord('0804f336', component.options)
    } else {
      api.reload('0804f336', component.options)
    }
    module.hot.accept("./Ranking.vue?vue&type=template&id=0804f336&", function () {
      api.rerender('0804f336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Ranking.vue"
export default component.exports